import * as React from "react";

export type MenuListProps = {
  name: string;
  icon?: React.ReactNode;
  onClick: () => void;
};

const MenuList: React.FC<{
  menuItems: MenuListProps[];
  menuDividerPositions: number[];
  onClick: () => void;
}> = ({ menuItems, menuDividerPositions, onClick }) => (
  <ul>
    {menuItems.map((item, index) => (
      <li key={item.name}>
        {menuDividerPositions && menuDividerPositions.includes(index) && (
          <hr className="is-marginless" />
        )}
        <button
          style={{ padding: "15px 20px" }}
          className="navbar-item"
          onClick={() => {
            item.onClick();
            onClick();
          }}
        >
          {item.icon}
          <span style={{ paddingLeft: "20px" }}>{item.name}</span>
        </button>
      </li>
    ))}
  </ul>
);

const logoImage =
  "data:image/svg+xml;base64,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";

export const Header: React.FC<{
  serviceName: string;
  fixed: boolean;
  onClickLogo: React.MouseEventHandler<HTMLAnchorElement> | null;
  menuLabel: React.ReactNode | string;
  menuIcon?: React.ReactNode;
  menuItems: MenuListProps[];
  menuDividerPositions: number[];
}> = ({
  serviceName,
  fixed,
  onClickLogo,
  menuLabel,
  menuIcon,
  menuItems,
  menuDividerPositions,
}) => {
  const [isMenuOpening, setIsMenuOpening] = React.useState(false);
  const menuRef = React.useRef<HTMLDivElement>(null);

  return (
    <header className={`navbar is-dark cm__header ${fixed && "is-fixed-top"}`}>
      <div className="container">
        <div className="navbar-brand">
          {onClickLogo ? (
            <a
              href=""
              onClick={(e) => {
                e.preventDefault();
                onClickLogo(e);
              }}
              className="navbar-item"
            >
              <img src={logoImage} alt="Graffer" />
              <span
                className="is-size-7 has-text-weight-bold"
                style={{ paddingLeft: "10px" }}
              >
                {serviceName}
              </span>
            </a>
          ) : (
            <div className="navbar-item">
              <img src={logoImage} alt="Graffer" />
              <span
                className="is-size-7 has-text-weight-bold"
                style={{ paddingLeft: "5px" }}
              >
                {serviceName}
              </span>
            </div>
          )}
          {menuItems && menuItems.length > 0 && (
            <button
              id="navbarBurger"
              data-target="navMenuDocumentation"
              className={`navbar-burger burger ${
                isMenuOpening ? "is-active" : ""
              }`}
              aria-haspopup="true"
              aria-expanded={isMenuOpening}
              aria-controls="navMenuBurger"
              aria-label="ナビゲーションメニュー"
              onClick={() => setIsMenuOpening((v: boolean) => !v as any)}
            >
              <span />
              <span />
              <span />
            </button>
          )}
        </div>
        {menuItems && menuItems.length > 0 && (
          <nav
            id="navMenuDocumentation"
            className={`navbar-menu ${isMenuOpening ? "is-active" : ""}`}
          >
            <div
              id="navMenuBurger"
              className="navbar-end is-hidden-desktop"
              aria-hidden={!isMenuOpening}
            >
              <MenuList
                menuItems={menuItems}
                menuDividerPositions={menuDividerPositions}
                onClick={() => setIsMenuOpening(false)}
              />
            </div>
            <div className="navbar-end is-hidden-touch">
              <div
                ref={menuRef}
                // bulmaの "navbar-item has-dropdown is-hoverable" の組み合わせでは、focusの時点でメニューが開いてしまうため、
                // is-hoverableではなく、is-activeをトグルする形で開閉を行う
                // https://bulma.io/documentation/components/navbar/#dropdown-menu
                className={`navbar-item has-dropdown ${
                  isMenuOpening ? "is-active" : ""
                }`}
                onMouseEnter={() => setIsMenuOpening(true)}
                onMouseLeave={() => setIsMenuOpening(false)}
                onBlur={(e) => {
                  // タブ操作で、メニューリスト外にfocusが移った時に、メニューを閉じる
                  if (!menuRef.current?.contains(e.relatedTarget as Node)) {
                    setIsMenuOpening(false);
                  }
                }}
              >
                <button
                  className="navbar-link has-text-weight-bold has-text-white"
                  style={{ fontSize: "14px" }}
                  aria-haspopup="true"
                  aria-expanded={isMenuOpening}
                  aria-controls="navMenuDropdown"
                  // タブ操作の場合、フォーカスが入って、Enterでメニューを開く挙動にしたいが、
                  // 既存のhoverで開く挙動を残したいため、
                  // onClickではなく、onKeyPressにてEnterとSpaceキーの時に開閉する
                  onKeyPress={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      setIsMenuOpening((v: boolean) => !v as boolean);
                    }
                  }}
                >
                  {menuIcon ? (
                    <span>
                      {menuIcon}
                      <span style={{ paddingLeft: "5px" }}>{menuLabel}</span>
                    </span>
                  ) : (
                    <span>{menuLabel}</span>
                  )}
                </button>
                <div
                  className="navbar-dropdown is-right"
                  id="navMenuDropdown"
                  aria-hidden={!isMenuOpening}
                >
                  <MenuList
                    menuItems={menuItems}
                    menuDividerPositions={menuDividerPositions}
                    onClick={() => setIsMenuOpening(false)}
                  />
                </div>
              </div>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};
